/**
 * React Query / cache key strings shared across the app.
 */
export const CACHE_KEYS = {
  allBargeControlDevices: 'allBargeControlDevices',
  bargeControlPlcs: 'bargeControlPlcs',
  allBilgePumps: 'allBilgePumps',
  allCameras: 'allCameras',
  allGioDevices: 'allGioDevices',
  allOrbitDevices: 'allOrbitDevices',
  allOrbitLedDevices: 'allOrbitLedDevices',
  allOrbitLedHubDevices: 'allOrbitLedHubDevices',
  allPresetGroups: 'allPresetGroups',
  allPresets: 'allPresets',
  allTanks: 'allTanks',
  allWaterlinkedDevices: 'allWaterlinkedDevices',
  automation: 'automation',
  automationApi: 'automationApi',
  autoDiscoverOrbitDevice: 'autoDiscoverOrbitDevice',

  boxplotData: 'boxplotData',

  cameraActivation: 'cameraActivation',
  cloudInventorySites: 'cloudInventorySites',

  events: 'events',
  frontendPodsNames: 'frontendPodsNames',

  startFeeding: 'startFeeding',

  generatorsApi: 'generatorsApi',

  initialSensorData: 'initial-sensor-data',
  inventory: 'inventory',
  inventoryDistinctTypes: 'inventoryDistinctTypes',
  inventoryApi: 'inventoryApi',
  inventoryAppVersion: 'inventoryAppVersion',
  inventoryCheckUsage: 'inventoryCheckUsage',
  inventoryHistory: 'inventoryHistory',
  inventoryHealth: 'inventoryHealth',
  inventoryName: 'inventoryName',
  inventorySensors: 'inventorySensors',
  inventorySiteInfo: 'inventorySiteInfo',

  logs: 'logs',
  fishObservations: 'fishObservations',
  fishCropImage: 'fishCropImage',

  measurementRanges: 'measurementRanges',
  measurementTypes: 'measurementTypes',
  measurements: 'measurements',

  morthandlingPlcs: 'morthandlingPlcs',

  biomassDailySummary: 'biomassDailySummary',
  biomassDistribution: 'biomassDistribution',

  welfareScores: 'welfareScores',

  opcUaServer: 'opcUaServer',
  orbitLedApi: 'orbitLedApi',

  podsNames: 'podsNames',

  scatterPlotData: 'scatterPlotData',
  statisticalAnalysis: 'statisticalAnalysis',

  templates: 'templates',

  userConfigLayout: 'userConfigLayout',
  userConfigSettings: 'userConfigSettings',
} as const;
